import {
  motion,
  MotionValue,
} from 'framer-motion';
import { MutableRefObject } from 'react';
import { ReactComponent as IndicatorSvg } from '../../assets/images/chests/spinner/indicator.svg';
import { ReactComponent as SeparatorSvg } from '../../assets/images/chests/spinner/separator.svg';
import { ReactComponent as SideSvg } from '../../assets/images/chests/spinner/side.svg';
import { TChestHistoryResponse, TChestResponse, TChestReward } from '../../types';
import ChestRewardCard from './components/ChestRewardCard';

type TChestSpinner = {
  scope: MutableRefObject<HTMLDivElement | null>
  x: MotionValue<number>;
  spinLine: TChestReward[]
  chest: TChestResponse | null
  multiplier: TChestHistoryResponse['multiplier'] | undefined
}

function ChestSpinner({
  scope, spinLine, x, chest, multiplier,
}: TChestSpinner) {
  if (!chest) {
    return null;
  }

  return (
    <div className="flex justify-between relative text-[#fff]">
      <div className="z-[1] flex justify-between items-center w-full">
        <SideSvg className="z-[1]" />
        <SideSvg className="transform scale-x-[-1]" />
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-between z-[1]">
        <IndicatorSvg className="transform translate-y-[-16%]" />
        <IndicatorSvg className="transform scale-y-[-1] translate-y-[16%]" />
      </div>
      <div className="
          absolute
          left-0 top-[50%]
          transform translate-y-[-50%]
          w-full h-[154px]
          font-Bangers
          bg-chestSpinElemBg
        "
      >
        <div className="absolute top-[50%] left-[50%] w-[154px] h-full transform translate-x-[-50%] translate-y-[-50%] bg-activeChestSpinElemBg">
          <SeparatorSvg className="absolute top-[50%] left-0 transform translate-x-[-50%] translate-y-[-50%]" />
          <SeparatorSvg className="absolute top-[50%] right-0 transform translate-x-[50%] translate-y-[-50%]" />
        </div>
        <div className="overflow-hidden">
          <motion.div
            className="
            flex
            w-full
          "
            ref={scope}
            style={{ x }}
          >
            {spinLine.map((cR, idx) => (
              <ChestRewardCard
              // eslint-disable-next-line react/no-array-index-key
                key={`chest-${cR.chest_id}-reward-${cR.id}-idx-${idx}`}
                chestReward={cR}
                multiplier={multiplier}
              />
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default ChestSpinner;
